module.exports = __webpack_public_path__ + "img/sc.90c9327b.svg";